(function(global){
  'use strict';
  function positions(arts,availableWidth,availableHeight){
    if(!arts.length)return [];
    var count=arts.length;
    var sizeFactor=[1,.98,.95,.92,.89,.86,.83][Math.min(6,count-1)];
    var width=availableHeight*.8*sizeFactor;
    var overlap=width*(count<3?.12:count<5?.24:.32);
    var left=0,items=[];
    arts.forEach(function(art,i){
      var b=art.pfpBounds||[0,0,255,319];
      var visibleWidth=(b[2]-b[0]+1)/256*width;
      var x=left-b[0]/256*width;
      items.push({left:x,width:width,center:x+width/2});
      left+=visibleWidth-(i<count-1?Math.min(overlap,visibleWidth*.34):0);
    });
    var scale=Math.min(1,availableWidth/Math.max(1,left));
    var offset=(availableWidth-left*scale)/2;
    return items.map(function(item){return {left:offset+item.left*scale,center:offset+item.center*scale,width:item.width*scale};});
  }
  global.FamilyLayoutV9={positions:positions};
})(typeof window==='undefined'?globalThis:window);
